import {
    defaultToolTip,
    getYearsMarks,
    YEARS
} from './components/vars';

export const initialState = {
    lat: "6.933517932891846",
    long: "133.60003662109375",
    scatterplotVariable: "home",
    variableSelected: null,
    sliderValue: 0,
    dateSelected: YEARS,
    markerSelected: getYearsMarks, // function reference
    sliderTooltip: defaultToolTip, // function reference
    colorbar: null,
    crwEnabled: false,
    currentJSON: false,
    currentOnClick: [],
    isSliderVisible: false,
    currentDial: ["2"],
    floodMetadata: null,
    isPlaying: false,
    crwArray: [0, 0, 0, 0],
};

export function dashboardReducer(state, action) {
    switch (action.type) {
        case 'UPDATE_CONFIG':
            // Optimization: Only update JSON paths if they actually changed.
            // Important: omit currentJSON from payload (undefined) must NOT wipe layers —
            // that previously blanked the map when OISST toggles cleared lat/long alone.
            const hasJSON = Object.prototype.hasOwnProperty.call(action.payload, 'currentJSON');
            const newJSON = action.payload.currentJSON;
            const jsonChanged = hasJSON && JSON.stringify(state.currentJSON) !== JSON.stringify(newJSON);
            return {
                ...state,
                ...action.payload,
                currentJSON: hasJSON
                    ? (jsonChanged ? newJSON : state.currentJSON)
                    : state.currentJSON,
                currentDial: action.payload.currentDial || state.currentDial,
            };
        case 'SET_LOCATION':
            return {
                ...state,
                lat: action.payload.lat,
                long: action.payload.long,
                scatterplotVariable: action.payload.scatterplotVariable || state.scatterplotVariable,
            };
        case 'SET_CRW_DATA':
             return { ...state, lat: action.payload.lat, long: action.payload.long, crwArray: action.payload.crwArray };
        case 'SET_METADATA':
            if (JSON.stringify(state.floodMetadata) === JSON.stringify(action.payload)) return state;
            return { ...state, floodMetadata: action.payload };
        case 'TOGGLE_PLAY':
            return { ...state, isPlaying: !state.isPlaying };
        default:
            return state;
    }
}
